// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1pZIf","table":"Table_table__1BfK9","btn":"Table_btn__6kH6X"};